if (typeof QuickAddToCart !== "function") {
  class QuickAddToCart extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector("product-form")) {
        this.init();
      }
    }
    init() {
      this.querySelector(".button").addEventListener("click", () => {
        this.closest("[data-js-product-item]").classList.add("null");
      });
      this.querySelector("product-form").addEventListener("add-to-cart", () => {
        this.closest("[data-js-product-item]").classList.remove("null");
        if (!document.body.classList.contains("template-cart")) {
          document.getElementById("site-cart-sidebar").show();
          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-count]",
              ).textContent;
            });
        }
      });
    }
  }

  if (typeof customElements.get("quick-add-to-cart") == "undefined") {
    customElements.define("quick-add-to-cart", QuickAddToCart);
  }
}

if (typeof QuickViewProduct !== "function") {
  class QuickViewProduct extends HTMLElement {
    constructor() {
      super();
      this.loadingPromise = null;
      if (this.querySelector(".button")) {
        this.init();
      }
    }

    init() {
      this.quickViewModal = null;
      this.querySelector("button").addEventListener("click", (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        if (this.quickViewModal) {
          this.quickViewModal.show();
          return;
        }

        if (!this.loadingPromise) {
          this.loadingPromise = this.load(target)
            .catch(() => window.location.assign(target.getAttribute("data-href")))
            .finally(() => {
              target.classList.remove("working");
              target.closest("[data-js-product-item]")?.classList.remove("null");
              this.loadingPromise = null;
            });
        }
      });
    }

    async fetchHTML(url) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(`Quick view request failed with ${response.status}`);
        return await response.text();
      } finally {
        window.clearTimeout(timeout);
      }
    }

    loadScript(src) {
      if (!src) return Promise.resolve();
      const absoluteSrc = new URL(src, window.location.href).href;
      window.quickViewScriptPromises = window.quickViewScriptPromises || new Map();
      if (window.quickViewScriptPromises.has(absoluteSrc)) {
        return window.quickViewScriptPromises.get(absoluteSrc);
      }
      if ([...document.querySelectorAll("script[src]")].some((script) => script.src === absoluteSrc)) {
        const promise = Promise.resolve();
        window.quickViewScriptPromises.set(absoluteSrc, promise);
        return promise;
      }

      const promise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = absoluteSrc;
        script.addEventListener("load", resolve, { once: true });
        script.addEventListener("error", reject, { once: true });
        document.body.appendChild(script);
      }).catch((error) => {
        window.quickViewScriptPromises.delete(absoluteSrc);
        throw error;
      });
      window.quickViewScriptPromises.set(absoluteSrc, promise);
      return promise;
    }

    waitForStyles() {
      const links = [...this.quickViewModal.querySelectorAll('link[rel="stylesheet"]')];
      return Promise.all(
        links.map((link) => {
          if (link.sheet) return Promise.resolve();
          return new Promise((resolve, reject) => {
            const timeout = window.setTimeout(resolve, 10000);
            link.addEventListener(
              "load",
              () => {
                window.clearTimeout(timeout);
                resolve();
              },
              { once: true },
            );
            link.addEventListener(
              "error",
              () => {
                window.clearTimeout(timeout);
                reject(new Error(`Unable to load ${link.href}`));
              },
              { once: true },
            );
          });
        }),
      );
    }

    async load(target) {
      target.classList.add("working");
      target.closest("[data-js-product-item]")?.classList.add("null");
      const productUrl = target.getAttribute("data-href");
      const requestUrl = `${productUrl}${productUrl.includes("?") ? "&" : "?"}view=quick-view`;
      const text = await this.fetchHTML(requestUrl);
      const quickViewHTML = new DOMParser().parseFromString(text, "text/html").querySelector("#product-quick-view");
      if (!quickViewHTML) throw new Error("Quick view response did not contain #product-quick-view");

      const quickViewContainer = document.createElement("div");
      quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"
        class="modal modal--product"
        data-options='{
          "enabled": false,
          "showOnce": false,
          "blockTabNavigation": true,
          "closeByKey": true,
          "openedModalBodyClass": "no-overflow"
        }'
        tabindex="-1" role="dialog" aria-modal="true"
      >
        <div class="product-modal-content" style="z-index:9"></div>
        <span class="modal-background" data-js-close></span>
      </modal-box>`;

      this.quickViewModal = quickViewContainer.querySelector("modal-box");
      document.body.appendChild(this.quickViewModal);
      this.quickViewModal.querySelector(".product-modal-content").innerHTML = `
        ${quickViewHTML.innerHTML}
        <button class="product-quick-view__close" data-js-close aria-label="${window.KROWN.settings.locales.close}">${window.KROWN.settings.symbols.close}</button>
      `;

      const productPage = this.quickViewModal.querySelector("product-page");
      if (!productPage) throw new Error("Quick view response did not contain product-page");
      ProductHeaderHelper(`#${productPage.id}`);

      const stylesPromise = this.waitForStyles();
      const scriptElements = [...this.quickViewModal.querySelectorAll("script[src]")];
      const scriptSources = [
        ...new Set(scriptElements.map((script) => script.src).filter(Boolean)),
      ];
      scriptElements.forEach((script) => script.remove());
      for (const src of scriptSources) {
        await this.loadScript(src);
      }
      await stylesPromise;

      this.quickViewModal.querySelector(".product-quick-view__close").addEventListener("click", () => {
        this.quickViewModal.hide();
      });
      this.quickViewModal.querySelector("[data-js-product-form]")?.addEventListener("add-to-cart", () => {
        this.quickViewModal.hide();
      });
      window.Shopify?.PaymentButton?.init?.();
      this.quickViewModal.show();
    }
  }

  if (typeof customElements.get("quick-view-product") == "undefined") {
    customElements.define("quick-view-product", QuickViewProduct);
  }
}
